import MillManagementFormScreen from './MillManagementFormScreen'

export default MillManagementFormScreen
